import { createSlice } from '@reduxjs/toolkit';

// Replace SecureStore functions with localStorage equivalents
const saveToken = async (key, value) => {
  localStorage.setItem(key, value);
};

const saveUser = async (key, value) => {
  localStorage.setItem(key, value);
};

const saveToStore = async (key, value) => {
  localStorage.setItem(key, value);
};

const initialState = {
  form: {
    fname: null,
    lname: null,
    email: null,
    password: null,
    password_confirmation: null,
    sexe: null,
    age: null,
    city: null,
    membership: null,
    dateOfBirth: null,
    golfer: null,
    sector: null,
    handicap: null,
    license: null,
    picture: {},
    phoneNumber: null,
    phoneCode: 'MA',
    callingCode: '212',
    country: 'Morocco',
    countryCode: 'MA',
    referred: null,
    company: null,
    position: null,
    club: null,
    lang: navigator.language.slice(0, 2), // Ensure this is correctly initialized
  },
  userToken: null,
  user: null,
  baseUrl : 'https://gtm.ma/sysgtm/public/api',
  // baseUrl: 'http://localhost:8000/api',
  defaultColor: "#608D40",
  profile: null,
  lang :  "en",
  count: 0,
};

export const formSlice = createSlice({
  name: 'gtm',
  initialState,
  reducers: {
    storeFname: (state, action) => {
      state.form.fname = action.payload;
    },
    storeLname: (state, action) => {
      state.form.lname = action.payload;
    },
    storeEmail: (state, action) => {
      state.form.email = action.payload;
    },
    storePassword: (state, action) => {
      state.form.password = action.payload;
    },
    storeConfirmPassword: (state, action) => {
      state.form.password_confirmation = action.payload;
    },
    storeSexe: (state, action) => {
      state.form.sexe = action.payload;
    },
    storeAge: (state, action) => {
      state.form.age = action.payload;
    },
    storeCity: (state, action) => {
      state.form.city = action.payload;
    },
    storeMembership: (state, action) => {
      state.form.membership = action.payload;
    },
    storeDateOfBirth: (state, action) => {
      state.form.dateOfBirth = action.payload;
    },
    storeGolfer: (state, action) => {
      state.form.golfer = action.payload;
    },
    storeSector: (state, action) => {
      state.form.sector = action.payload;
    },
    storeHandicap: (state, action) => {
      state.form.handicap = action.payload;
    },
    storeLicense: (state, action) => {
      state.form.license = action.payload;
    },
    storePicture: (state, action) => {
      state.form.picture = action.payload;
    },
    storePhoneNumber: (state, action) => {
      state.form.phoneNumber = action.payload;
    },
    storeCountry: (state, action) => {
      state.form.country = action.payload;
    },
    storeCountryCode: (state, action) => {
      state.form.countryCode = action.payload;
    },
    storePhoneCode: (state, action) => {
      state.form.phoneCode = action.payload;
    },
    storeCallingCode: (state, action) => {
      state.form.callingCode = action.payload;
    },
    storeReferredBy: (state, action) => {
      state.form.referred = action.payload;
    },
    storeCompany: (state, action) => {
      state.form.company = action.payload;
    },
    storePosition: (state, action) => {
      state.form.position = action.payload;
    },
    storeClub: (state, action) => {
      state.form.club = action.payload;
    },
    storeToken: (state, action) => {
      state.form.userToken = action.payload;
      saveToken('userToken', action.payload);
    },
    storeUser: (state, action) => {
      state.form.user = action.payload;
      saveUser('user', JSON.stringify(state.form.user));
    },
    updateUser: (state, action) => {
      state.form.user = action.payload;
      saveUser('user', JSON.stringify(state.form.user));
    },
    storeProfile: (state, action) => {
      state.profile = action.payload;

    },
    updateLang: (state, action) => {
      state.lang = action.payload;

      
    },
    storeCount: (state , action) => {
      state.count = action.payload

      
    },
  },
});

export const {
  storeProfile,
  storeFname,
  storeLname,
  storeEmail,
  storePassword,
  storeSexe,
  storeAge,
  storeCity,
  storeMembership,
  storeReferredBy,
  storeDateOfBirth,
  storeSector,
  storeHandicap,
  storeLicense,
  storeConfirmPassword,
  storePicture,
  storeCountry,
  storeCountryCode,
  storePhoneNumber,
  storePhoneCode,
  storeCallingCode,
  storeGolfer,
  storeCompany,
  storePosition,
  storeClub,
  storeToken,
  storeUser,
  updateUser,
  updateLang,
  storeCount,
} = formSlice.actions;

export default formSlice.reducer;
